import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "style", "as", "css", "htmlTag", "variant", "color", "textAlign"];
import React from "react";
import useTypographyColors from "./hooks/useTypographyColors";
import useTypographyElementFromTagProp from "./hooks/useTypographyElementFromTagProp";
import { BaseTypography } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function Typography(_ref) {
  var className = _ref.className,
    style = _ref.style,
    as = _ref.as,
    css = _ref.css,
    htmlTag = _ref.htmlTag,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "body" : _ref$variant,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "hiContrast" : _ref$color,
    textAlign = _ref.textAlign,
    rest = _objectWithoutProperties(_ref, _excluded);
  var renderedComponent = useTypographyElementFromTagProp(htmlTag, variant);
  var colorProps = useTypographyColors(color);
  return /*#__PURE__*/_jsx(BaseTypography, _extends({}, rest, {
    as: renderedComponent,
    variant: variant,
    textAlign: textAlign
  }, colorProps));
}
export default Typography;